/**
 * 游戏入口（汇总注册）
 * ------------------------------------------------------------
 * 新增游戏时：在 src/games/<id>/index.js 里 registerGame()，
 * 然后在这里加一行 import —— 这一行只是让打包器把文件包含进来。
 */
import './elf-rescue/index.js';

import { gameRegistry } from './registry.js';

export { gameRegistry, registerGame, GameBase } from './registry.js';

/** 读取 data/games.json（展示用的元数据：图标、简介、难度、上下架状态） */
let metaCache = null;
export async function loadGameMeta() {
  if (metaCache) return metaCache;
  try {
    if (typeof window !== 'undefined' && window.__INLINE_DATA__?.['data/games.json']) {
      metaCache = window.__INLINE_DATA__['data/games.json'];
      return metaCache;
    }
    const url = new URL('data/games.json', document.baseURI).href;
    const res = await fetch(url, { cache: 'no-cache' });
    metaCache = await res.json();
  } catch {
    metaCache = { games: [] };
  }
  return metaCache;
}

/** 把「代码里注册的游戏」与「JSON 里的元数据」对上，返回用于渲染的列表 */
export async function listGames() {
  const { games = [] } = await loadGameMeta();
  const metaMap = new Map(games.map(g => [g.id, g]));
  return gameRegistry.all().map(m => ({
    ...(metaMap.get(m.id) || {}),
    ...m,
    // JSON 里若标了 planned，则视为未上线
    available: (metaMap.get(m.id)?.status ?? 'available') === 'available',
  }));
}

/** JSON 里声明了但代码尚未实现的游戏（用于「敬请期待」展示） */
export async function plannedGames() {
  const { games = [] } = await loadGameMeta();
  return games.filter(g => g.status === 'planned' || !gameRegistry.has(g.id));
}
